import React, { useState } from "react";
import Header from "../components/Header";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/menu.css";
import "../assets/css/vendors.css";
import "../assets/css/icon_fonts/css/all_icons_min.css";
import "../assets/css/custom.css";

const doctorsData = [
  {
    name: "Dr. Priya Sharma",
    qualification: "MBBS, MS - Obstetrics & Gynecology",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "15 Years Experience",
    location: "2nd Floor, MS Tower, Banjara Hills, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Fibroid Treatment Specialist"
  },
  {
    name: "Dr. Anjali Mehta",
    qualification: "MBBS, DNB - Gynecologic Surgery",
    fee: " FREE Consultation",
    rating: "4.9/5",
    experience: "12 Years Experience",
    location: "Apurupa Urban, No 201, 2nd Floor, Image Gardens Rd, near Chirec School, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Minimally Invasive Surgery Expert"
  },
  {
    name: "Dr. Rohan Verma",
    qualification: "MBBS, MS - Obstetrics & Gynecology",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "14 Years Experience",
    location: "Annapurna Kalyana Mandapam Srinagar Nagar, Dilsukhnagar, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Uterine Preservation Specialist"
  },
  {
    name: "Dr. Sneha Reddy",
    qualification: "MBBS, MD - Reproductive Medicine",
    fee: " FREE Consultation",
    rating: "4.6/5",
    experience: "11 Years Experience",
    location: "123 Green Avenue, Banjara Hills, Hyderabad",
    phone: "080-6541-7710",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Fertility Preservation Expert"
  },
  {
    name: "Dr. Kavita Patel",
    qualification: "MBBS, MS - Obstetrics & Gynecology",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "16 Years Experience",
    location: "45 Tower Road, Jubilee Hills, Hyderabad",
    phone: "080-6541-7720",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Advanced Fibroid Care"
  },
  {
    name: "Dr. Arjun Kumar",
    qualification: "MBBS, MD - Gynecology",
    fee: "FREE Consultation",
    rating: "4.7/5",
    experience: "13 Years Experience",
    location: "21 MG Road, Hyderabad",
    phone: "080-6541-7730",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Non-Surgical Treatment Expert"
  },
];

const DoctorsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedDoctors = showAll ? doctorsData : doctorsData.slice(0, 6);

  return (
    <div style={{ padding: "80px 20px", backgroundColor: "#f8f9fa" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", fontFamily: "'Poppins', sans-serif" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "42px", fontWeight: "800", color: "#0b1c39", marginBottom: "15px" }}>
            Our <span style={{ color: "#ffcb24" }}>Fibroid Treatment Specialists</span>
          </h2>
          <p style={{ fontSize: "18px", color: "#555", maxWidth: "600px", margin: "0 auto", lineHeight: "1.8" }}>
            Expert care for uterine fibroids with advanced surgical and non-surgical treatments for fertility preservation and symptom relief.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", justifyContent: "space-between" }}>
          {displayedDoctors.map((doc, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 calc(33.33% - 17px)",
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                border: "1px solid rgba(9,187,175,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)";
              }}
            >
              <div style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={doc.image}
                  alt={doc.name}
                  style={{
                    width: "95px",
                    height: "95px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #09bbaf",
                    backgroundColor: "#f8f8f8",
                  }}
                />
                {doc.online && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "8px",
                      width: "14px",
                      height: "14px",
                      backgroundColor: "#09bbaf",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                    }}
                    title="Online"
                  ></span>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0b1c39", marginBottom: "6px" }}>
                  {doc.name}
                </h3>
                <p style={{ color: "#09bbaf", fontSize: "14px", marginBottom: "6px", fontWeight: "600" }}>
                  {doc.specialization}
                </p>
                <p style={{ color: "#555", fontSize: "14px", marginBottom: "6px" }}>
                  {doc.qualification}
                </p>
                <p style={{ fontWeight: "600", color: "#09bbaf", marginBottom: "6px", fontSize: "15px" }}>
                  {doc.fee}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "14px", color: "#555" }}>⭐ {doc.rating}</span>
                  <span style={{ fontSize: "14px", color: "#555" }}>{doc.experience}</span>
                </div>
                <p style={{ fontSize: "13px", color: "#555", display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "6px", lineHeight: "1.4" }}>
                  📍 {doc.location}
                </p>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "15px" }}>
                  📞 {doc.phone}
                </p>

                <button
                  style={{
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "30px",
                    backgroundColor: "#ffcb24",
                    color: "#0b1c39",
                    cursor: "pointer",
                    width: "100%",
                    fontWeight: "600",
                    fontSize: "14px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd84f")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffcb24")}
                >
                  Book Free Consultation
                </button>
              </div>
            </div>
          ))}
        </div>

        {!showAll && doctorsData.length > 6 && (
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => setShowAll(true)}
              style={{
                padding: "14px 40px",
                fontSize: "16px",
                borderRadius: "12px",
                border: "none",
                backgroundColor: "#09bbaf",
                color: "#fff",
                cursor: "pointer",
                fontWeight: "700",
                boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0dcfc2")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#09bbaf")}
            >
              View More Doctors ▼
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const UterineFibroidsTreatment = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <>
      <Header />
      <Header2 />

      {/* Hero Section */}
      <section style={{
        background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
        padding: "160px 0 100px",
        marginTop: "56px",
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <h1 style={{
            fontSize: "3.5rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "white"
          }}>
            Comprehensive Uterine Fibroids Treatment
          </h1>
          <p style={{
            fontSize: "1.3rem",
            marginBottom: "30px",
            opacity: "0.9",
            maxWidth: "700px",
            margin: "0 auto 30px",
            lineHeight: "1.6"
          }}>
            Advanced Surgical and Non-Surgical Treatments with 95% Success Rate. Fertility Preservation and Symptom Relief.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book Free Consultation
            </button>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "2px solid #ffcb24",
              backgroundColor: "transparent",
              color: "#ffcb24",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.color = "#0b1c39";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#ffcb24";
            }}>
              Fertility Preservation Options
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ backgroundColor: "#fff", padding: "60px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>70-80%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Women Affected by Age 50</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>95%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Treatment Success Rate</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>85%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Fertility Preservation Success</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>2-4</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Weeks Recovery Time</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Section */}
      <DoctorsSection />

      {/* Navigation Tabs */}
      <section style={{ backgroundColor: "#fff", padding: "40px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
            {[
              { id: "overview", label: "Overview", icon: "📋" },
              { id: "symptoms", label: "Symptoms", icon: "🔍" },
              { id: "types", label: "Types", icon: "🎯" },
              { id: "diagnosis", label: "Diagnosis", icon: "🔬" },
              { id: "treatment", label: "Treatment", icon: "⚕️" },
              { id: "fertility", label: "Fertility", icon: "🔄" },
              { id: "recovery", label: "Recovery", icon: "🛡️" }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: "12px 24px",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: activeTab === tab.id ? "#09bbaf" : "#f8f9fa",
                  color: activeTab === tab.id ? "white" : "#555",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container" style={{ padding: "80px 15px" }}>

        {/* Comprehensive Overview */}
        <section style={{ marginBottom: "80px" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 style={{ fontSize: "36px", fontWeight: "800", color: "#0b1c39", marginBottom: "20px" }}>
              Complete Guide to <span style={{ color: "#09bbaf" }}>Uterine Fibroids Treatment</span>
            </h2>
          </div>

          {/* What are Uterine Fibroids */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "50px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "1px solid rgba(9,187,175,0.1)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px" }}>
                Understanding Uterine Fibroids
              </h3>
              
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "1.1rem", marginBottom: "25px" }}>
                Uterine fibroids are non-cancerous growths that develop in or on the uterus. These benign tumors 
                are composed of muscle and fibrous tissue and can vary in size from seedlings to large masses that 
                can distort and enlarge the uterus. While fibroids are rarely associated with cancer, they can cause 
                significant symptoms that impact quality of life.
              </p>

              <div className="row">
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #09bbaf",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Common Condition</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Fibroids affect 70-80% of women by age 50, making them one of the most common 
                      gynecological conditions requiring medical attention.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #ffcb24",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Treatment Options</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Multiple treatment approaches available ranging from medication management to 
                      minimally invasive procedures and surgical options based on individual needs.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Detailed Symptoms */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Symptoms Guide
            </h3>

            <div className="row">
              {[
                {
                  title: "Heavy Menstrual Bleeding", 
                  description: "Prolonged, heavy periods that may lead to anemia and fatigue",
                  details: "Most common symptom, often requiring frequent pad/tampon changes"
                },
                {
                  title: "Pelvic Pain & Pressure", 
                  description: "Constant dull ache or feeling of fullness in lower abdomen",
                  details: "Caused by fibroids pressing on surrounding organs and tissues"
                },
                {
                  title: "Frequent Urination", 
                  description: "Need to urinate more often due to bladder pressure",
                  details: "Fibroids can compress bladder reducing its capacity"
                },
                {
                  title: "Backache & Leg Pains", 
                  description: "Radiating pain in lower back and legs from nerve pressure",
                  details: "Particularly common with large posterior wall fibroids"
                },
                {
                  title: "Pain During Intercourse", 
                  description: "Discomfort or pain during sexual activity",
                  details: "Affects 30-40% of women with symptomatic fibroids"
                },
                {
                  title: "Reproductive Issues", 
                  description: "Difficulty conceiving, recurrent miscarriages, or pregnancy complications",
                  details: "Fibroids can interfere with implantation and fetal development"
                }
              ].map((symptom, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    padding: "25px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(9,187,175,0.1)",
                    height: "100%",
                    transition: "transform 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                      {symptom.title}
                    </h5>
                    <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                      {symptom.description}
                    </p>
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      padding: "12px",
                      borderLeft: "3px solid #09bbaf"
                    }}>
                      <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: "1.5", margin: 0 }}>
                        {symptom.details}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Fibroid Types */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Types of Uterine Fibroids
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    type: "Submucosal Fibroids",
                    description: "Grow just under the uterine lining into the uterine cavity",
                    treatment: "Hysteroscopic resection, Medical management, UFE"
                  },
                  {
                    type: "Intramural Fibroids",
                    description: "Develop within the uterine wall and expand making uterus feel larger",
                    treatment: "Myomectomy, UFE, Medical therapy, Focused ultrasound"
                  },
                  {
                    type: "Subserosal Fibroids",
                    description: "Project to the outside of the uterus, may press on other organs",
                    treatment: "Laparoscopic myomectomy, UFE, Surgical removal"
                  },
                  {
                    type: "Pedunculated Fibroids",
                    description: "Grow on stalks either inside or outside the uterus",
                    treatment: "Hysteroscopic or laparoscopic removal, Myomectomy"
                  },
                  {
                    type: "Cervical Fibroids",
                    description: "Located in the wall of the cervix rather than uterine body",
                    treatment: "Specialized surgical removal, Medical management"
                  },
                  {
                    type: "Multiple Fibroids",
                    description: "Presence of several fibroids of different types and sizes",
                    treatment: "Combined approach, Myomectomy, UFE, Hysterectomy"
                  }
                ].map((type, index) => (
                  <div key={index} className="col-lg-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "2px solid #09bbaf",
                      height: "100%"
                    }}>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                        {type.type}
                      </h5>
                      <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                        {type.description}
                      </p>
                      <div style={{
                        backgroundColor: "#09bbaf",
                        color: "white",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        display: "inline-block",
                        fontSize: "0.9rem",
                        fontWeight: "600"
                      }}>
                        {type.treatment}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Causes and Risk Factors */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#0b1c39",
              borderRadius: "20px",
              padding: "50px",
              color: "white"
            }}>
              <h3 style={{ fontSize: "28px", fontWeight: "800", marginBottom: "30px", color: "#ffcb24" }}>
                Causes & Risk Factors
              </h3>
              
              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Development Factors</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Hormonal influences (estrogen and progesterone)</li>
                      <li style={{ marginBottom: "10px" }}>Genetic changes in uterine muscle cells</li>
                      <li style={{ marginBottom: "10px" }}>Growth factors affecting tissue maintenance</li>
                      <li style={{ marginBottom: "10px" }}>Extracellular matrix changes increasing stiffness</li>
                      <li>Stem cell abnormalities in uterine tissue</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Risk Factors</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Age (most common in 30s-40s)</li>
                      <li style={{ marginBottom: "10px" }}>Family history of fibroids</li>
                      <li style={{ marginBottom: "10px" }}>African-American ethnicity</li>
                      <li style={{ marginBottom: "10px" }}>Obesity and higher body weight</li>
                      <li>Early onset of menstruation</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Options */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Treatment Approaches
            </h3>

            <div className="row">
              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #09bbaf",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Non-Surgical & Medical Management
                  </h4>
                  
                  <p style={{ color: "#555", lineHeight: "1.8", marginBottom: "25px" }}>
                    Many women with fibroids can be effectively managed with non-surgical approaches 
                    that control symptoms and slow fibroid growth. These options are particularly 
                    suitable for women who wish to preserve fertility or avoid surgery.
                  </p>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Medication Options:</h6>
                    <div className="row">
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>GnRH agonists (Lupron)</li>
                          <li style={{ marginBottom: "8px" }}>Tranexamic acid for bleeding</li>
                          <li style={{ marginBottom: "8px" }}>Progestin-releasing IUD</li>
                        </ul>
                      </div>
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>NSAIDs for pain management</li>
                          <li style={{ marginBottom: "8px" }}>Oral contraceptives</li>
                          <li style={{ marginBottom: "8px" }}>Selective progesterone modulators</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Minimally Invasive Procedures:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "8px" }}>Uterine Artery Embolization (UAE)</li>
                      <li style={{ marginBottom: "8px" }}>MRI-guided Focused Ultrasound</li>
                      <li style={{ marginBottom: "8px" }}>Endometrial Ablation</li>
                      <li>Radiofrequency Ablation</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #ffcb24",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Surgical Treatment Options
                  </h4>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Uterine-Preserving Surgery:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Myomectomy (fibroid removal only)</li>
                      <li style={{ marginBottom: "10px" }}>Laparoscopic myomectomy</li>
                      <li style={{ marginBottom: "10px" }}>Hysteroscopic myomectomy</li>
                      <li style={{ marginBottom: "10px" }}>Robotic-assisted myomectomy</li>
                      <li>Abdominal myomectomy for large fibroids</li>
                    </ul>
                  </div>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Definitive Surgical Options:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Hysterectomy (uterus removal)</li>
                      <li style={{ marginBottom: "10px" }}>Laparoscopic hysterectomy</li>
                      <li style={{ marginBottom: "10px" }}>Vaginal hysterectomy</li>
                      <li style={{ marginBottom: "10px" }}>Abdominal hysterectomy</li>
                      <li>Robotic hysterectomy</li>
                    </ul>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Procedure Selection:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Based on fibroid size, number and location</li>
                      <li style={{ marginBottom: "10px" }}>Patient's age and fertility desires</li>
                      <li>Symptom severity and impact on quality of life</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Fertility and Fibroids */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Fertility Preservation & Treatment
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    period: "Small Fibroids",
                    title: "Minimal Impact",
                    activities: ["Observation", "Medical management", "Natural conception", "Regular monitoring"]
                  },
                  {
                    period: "Submucosal",
                    title: "High Impact",
                    activities: ["Hysteroscopic removal", "IVF consideration", "Embryo freezing", "Pre-treatment planning"]
                  },
                  {
                    period: "Multiple/Large",
                    title: "Moderate Impact",
                    activities: ["Myomectomy planning", "Fertility assessment", "Individualized approach", "Timing optimization"]
                  },
                  {
                    period: "Post-Treatment",
                    title: "Fertility After Care",
                    activities: ["Healing period", "Conception timing", "Pregnancy monitoring", "Delivery planning"]
                  }
                ].map((approach, index) => (
                  <div key={index} className="col-lg-3 col-md-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      textAlign: "center",
                      border: "1px solid rgba(9,187,175,0.2)",
                      height: "100%"
                    }}>
                      <div style={{ 
                        backgroundColor: "#09bbaf", 
                        color: "white", 
                        width: "60px", 
                        height: "60px", 
                        borderRadius: "50%", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        margin: "0 auto 15px",
                        fontWeight: "700",
                        fontSize: "0.9rem"
                      }}>
                        {approach.period}
                      </div>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {approach.title}
                      </h5>
                      <ul style={{ color: "#555", fontSize: "0.85rem", paddingLeft: "15px", textAlign: "left" }}>
                        {approach.activities.map((activity, idx) => (
                          <li key={idx} style={{ marginBottom: "8px" }}>{activity}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Recovery and Long-term Management */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "2px solid rgba(255,203,36,0.3)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px", textAlign: "center" }}>
                Recovery & Long-term Management
              </h3>

              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Post-Treatment Recovery</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Minimally invasive: 1-2 weeks return to normal</li>
                      <li style={{ marginBottom: "10px" }}>Myomectomy: 4-6 weeks for full recovery</li>
                      <li style={{ marginBottom: "10px" }}>Hysterectomy: 6-8 weeks recovery period</li>
                      <li>Gradual return to activities with medical guidance</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Long-term Strategies</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Regular monitoring for recurrence</li>
                      <li style={{ marginBottom: "10px" }}>Healthy lifestyle and weight management</li>
                      <li style={{ marginBottom: "10px" }}>Hormonal management if needed</li>
                      <li>Fertility planning and pregnancy timing</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Frequently Asked Questions
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              {[
                {
                  question: "Can uterine fibroids turn into cancer?",
                  answer: "Uterine fibroids are almost always benign (non-cancerous). The risk of a fibroid being cancerous (leiomyosarcoma) is extremely rare, estimated at less than 1 in 1,000 cases. Cancerous growths in the uterus are typically not fibroids that have transformed but are different types of tumors that may be mistaken for fibroids initially. However, rapid growth of a presumed fibroid, particularly in postmenopausal women not taking hormone therapy, should be evaluated carefully. Our comprehensive diagnostic approach including ultrasound, MRI, and when necessary, biopsy, ensures accurate diagnosis and appropriate management. Regular monitoring and prompt evaluation of any concerning changes provide additional safety."
                },
                {
                  question: "What is the difference between myomectomy and hysterectomy?",
                  answer: "Myomectomy and hysterectomy are two different surgical approaches for fibroid treatment. Myomectomy is a uterus-preserving procedure where only the fibroids are removed, leaving the uterus intact. This is the preferred option for women who wish to preserve fertility or maintain their uterus. Hysterectomy involves complete removal of the uterus and is a definitive treatment that eliminates both fibroids and the possibility of future pregnancy. The choice between these procedures depends on multiple factors including the size, number and location of fibroids, the severity of symptoms, the patient's age, and most importantly, her reproductive plans. We thoroughly discuss both options with patients to ensure they make informed decisions aligned with their personal goals and health needs."
                },
                {
                  question: "How effective is uterine artery embolization (UAE) for fibroid treatment?",
                  answer: "Uterine artery embolization (UAE) is a highly effective minimally invasive treatment for fibroids, with success rates of 85-95% for symptom relief. The procedure works by blocking the blood supply to fibroids, causing them to shrink. Most women experience significant improvement in heavy bleeding within the first few menstrual cycles after UAE, and reduction in bulk-related symptoms (pressure, pain) over 3-6 months as fibroids shrink. UAE is particularly effective for multiple fibroids and can reduce fibroid volume by 40-60% on average. The advantages include no surgical incision, shorter recovery time (1-2 weeks), and uterus preservation. However, it may not be suitable for women who wish to conceive in the future, as its effects on fertility are not fully established. We carefully evaluate each patient to determine if UAE is the right option for their specific situation."
                },
                {
                  question: "Can fibroids grow back after treatment?",
                  answer: "The likelihood of fibroid recurrence depends on the treatment method chosen. After myomectomy (fibroid removal while preserving the uterus), there is a recurrence rate of approximately 10-30% over several years, as new fibroids can develop from microscopic seeds not visible during surgery. The recurrence risk is higher in women with multiple fibroids and those who are younger at the time of surgery. After hysterectomy (uterus removal), fibroids cannot recur since the uterus is removed. With uterine artery embolization, treated fibroids do not regrow, but new fibroids can develop over time. Non-surgical treatments like medications typically provide temporary relief and symptoms may return after discontinuation. We discuss recurrence risks during treatment planning and establish appropriate follow-up protocols to monitor for any new fibroid development."
                },
                {
                  question: "What lifestyle changes can help manage fibroid symptoms?",
                  answer: "Several lifestyle modifications can help manage fibroid symptoms and potentially slow their growth: Maintaining a healthy weight through diet and exercise, as excess body fat can increase estrogen levels that fuel fibroid growth; Eating a balanced diet rich in fruits, vegetables, and whole grains while reducing red meat consumption; Managing stress through techniques like yoga, meditation, or regular exercise; Staying physically active to improve circulation and reduce pelvic congestion; Avoiding environmental estrogens found in some plastics and pesticides; Considering acupuncture or traditional therapies for symptom relief; Monitoring iron levels and addressing anemia if heavy bleeding occurs. While lifestyle changes cannot eliminate fibroids, they can significantly improve symptoms and quality of life, and may be used alongside medical treatments for comprehensive management."
                }
              ].map((faq, index) => (
                <div key={index} style={{ 
                  marginBottom: "25px",
                  paddingBottom: "25px",
                  borderBottom: index < 4 ? "1px solid #eee" : "none"
                }}>
                  <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "10px" }}>
                    {faq.question}
                  </h5>
                  <p style={{ color: "#555", lineHeight: "1.6", margin: 0 }}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div style={{
            background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
            borderRadius: "20px",
            padding: "60px 40px",
            textAlign: "center",
            color: "white"
          }}>
            <h2 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "20px" }}>
              Ready to Find Relief from Fibroid Symptoms?
            </h2>
            <p style={{ fontSize: "1.2rem", marginBottom: "30px", opacity: "0.9", maxWidth: "600px", margin: "0 auto 30px" }}>
              Our expert team provides comprehensive fibroid care with advanced treatment options and fertility preservation.
            </p>
            <button style={{
              padding: "18px 45px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "800",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book FREE Fibroid Consultation
            </button>
            <p style={{ marginTop: "20px", fontSize: "1rem", opacity: "0.8" }}>
              Women's Health: <strong>080-6541-7705</strong> | Fertility Services: <strong>080-6541-7706</strong>
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default UterineFibroidsTreatment;